export const GET_FISCAL_CODE_REQUEST = 'GET_FISCAL_CODE_REQUEST';
export const GET_FISCAL_CODE_SUCCESS = 'GET_FISCAL_CODE_SUCCESS';
export const SET_IS_EINVOICE_SHOWED = 'SET_IS_EINVOICE_SHOWED';
export const GET_CITIES_REQUEST = 'GET_CITIES_REQUEST';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const CLEAR_INVOICE_CITIES = 'CLEAR_INVOICE_CITIES';
export const SET_EINVOICE_ENABLE_PARAM = 'SET_EINVOICE_ENABLE_PARAM';
